export const LOAD_FEEDS = 'LOAD_FEEDS'
export const ADD_FEED = 'ADD_FEED'
export const LOAD_FEED_COMMENTS = 'LOAD_FEED_COMMENTS'
export const ADD_FEED_COMMENT = 'ADD_FEED_COMMENT'
export const DELETE_FEED = 'DELETE_FEED'
export const LOAD_FEED_REACTIONS = 'LOAD_FEED_REACTIONS'
export const LOAD_NEXT_FEEDS = 'LOAD_NEXT_FEEDS'